import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const noteTemplatesAdapter = getAdapter();

const noteTemplatesSlice = createSlice({
  name: 'noteTemplates',
  initialState: noteTemplatesAdapter.getInitialState(),
  reducers: {
    setNoteTemplates: (state, { payload: { noteTemplates } }) => {
      noteTemplatesAdapter.setAll(state, noteTemplates);
    },
  },
});

const selectors = noteTemplatesAdapter.getSelectors(({ noteTemplates }) => noteTemplates);

export const getNoteTemplates = (state) => selectors.selectAll(state);

export const {
  setNoteTemplates,
} = noteTemplatesSlice.actions;

export default noteTemplatesSlice.reducer;
